'use client';

import { Tabs, type TabsProps } from 'antd';
import { useRouter, useSearchParams } from 'next/navigation';
import { useCallback } from 'react';
import styles from './AppTabs.module.scss';

type AppTabsProps = {
  tabs: TabsProps['items'];
};

export function AppTabs({ tabs }: AppTabsProps) {
  const router = useRouter();
  const searchParams = useSearchParams();
  const activeKey = searchParams.get('app') || 'TBA-WEB';

  const onChange = useCallback(
    (key: string) => {
      const params = new URLSearchParams(searchParams.toString());
      params.set('app', key);
      params.delete('page');
      router.push(`?${params.toString()}`);
    },
    [router, searchParams],
  );

  return (
    <div className={styles.categoryTabs}>
      <Tabs defaultActiveKey="TBA-WEB" activeKey={activeKey} onChange={onChange} items={tabs} />
    </div>
  );
}
